import React from 'react'

const Loading = ({message}) => {
  return (
    <div style={{display: 'flex', flexDirection:'row'}}>

        <div className='loadingComponent'>
          
          <div className='spiner'>
          
          </div>
        </div>

        <span> {message}</span>
    </div>
  )
}

export default Loading